<template>
  <div
    class="select-product"
    :class="{
      selected: (hasSelectProduct || hasLoadPaytype) && !isGsOrSupPayAutoSelect,
      hasProduct:
        (productList.length || searchVal || gameActiveCouponId) &&
        (notCartAndNoSelectProduct || isCartAndNoLoadPaytype)
    }"
  >
    <section-title
      :title="letter.storeSelectProductTitle"
      class="choose-product-title"
      v-if="!isGsOrSupPayAutoSelect"
    ></section-title>
    <!-- 分享按钮 -->
    <a
      v-if="useShare"
      href="javascript:;"
      @click="setSharePopup(true)"
      class="share-page-btn"
    ></a>
    <p class="unlogin-tip" v-if="!isLogin">{{ letter.storeSelectAndLook }}</p>
    <p
      class="coinTips"
      v-if="
        showCoinTips &&
        (productList.length || searchVal || gameActiveCouponId) &&
        (notCartAndNoSelectProduct || isCartAndNoLoadPaytype)
      "
    >
      {{ letter.coinUseTips }}
    </p>
    <div
      class="search-type-wrap"
      v-show="
        (productList.length || searchVal || gameActiveCouponId) &&
        (notCartAndNoSelectProduct || isCartAndNoLoadPaytype)
      "
    >
      <p v-html="currencyTips" v-if="currencyTips" class="tips"></p>
      <div class="search-wrap">
        <Select
          icon="selectvh"
          rightSpan="37px"
          class="select-search-type"
          v-model="curSearchType"
        >
          <template slot="option">
            <option
              v-for="item in searchType"
              :key="item.value"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </template>
          <template slot="ico">
            <em class="ico"></em>
          </template>
        </Select>
        <div class="search-input-wrap">
          <input
            :placeholder="searchPlaceholder[curSearchType]"
            class="search-input"
            v-model.trim="searchVal"
            type="search"
          />
          <em class="search-input-ico"></em>
        </div>
      </div>
      <div
        v-show="productType && !!productType.length"
        class="product-type-select"
        :class="[lang]"
        ref="productTypeWrap"
        id="productTypeWrap"
      >
        <div class="content" ref="productTypeContent">
          <template v-for="item in productType">
            <div
              class="product-type-select-item j-select-product-type"
              :pointValue="item.value"
              pointClass="`j-select-product-type`"
              :class="{ cur: curProductType == item.value }"
              :key="item.value"
            >
              <img
                :src="productTypeImg[item.value].img"
                class="type-img"
                alt=""
              />
              <p class="type-name">{{ item.name }}</p>
              <div
                class="product-type-select-item-click"
                @click="updateProductType(item.value)"
              ></div>
            </div>
          </template>
        </div>
      </div>
      <p class="search-tips" v-if="!productList.length && searchVal">
        {{ letter.storeNoFindProduct }}
      </p>
      <a
        v-if="isBlackFridayVersion"
        href="javascript:;"
        class="voucher-about-btn"
        @click="showVoucherAboutPopup"
      >
        {{ letter.aboutCoins }}
        <em class="about-icon"></em>
      </a>
    </div>
    <div
      class="order-type-wrap"
      v-show="
        (productList.length && notCartAndNoSelectProduct) ||
        isCartAndNoLoadPaytype
      "
    >
      <div class="order-type-wrap-left">
        <button
          class="order-btn j-select-order"
          :class="{ active: curOrderType === 'normal' }"
          @click="updateOrderType('normal')"
        >
          {{ letter.orderNormal }}
        </button>
        <button
          class="order-btn j-select-order"
          :class="{ active: curOrderType !== 'normal' }"
          @click="updateOrderType()"
        >
          {{
            curOrderType === 'priceDown'
              ? letter.storePriceDown
              : letter.storePriceUp
          }}
        </button>
      </div>
      <div class="order-type-wrap-right">
        <button class="coupon-tag" v-if="gameActiveCouponId">
          {{ letter.couponCanUseQuan }}
          <span class="coupon-tag-close" @click="resetGameActiveCoupon"></span>
        </button>
      </div>
    </div>
    <p class="uid-tips" v-if="uidGame">{{ letter.webStoreUidTips }}</p>
    <div
      class="product-wrap"
      v-show="notCartAndNoSelectProduct || isCartAndNoLoadPaytype"
    >
      <div class="product-box-wrap">
        <product-item
          v-for="(item, index) in productList"
          :key="item.PRODUCT_ID + item.CP_PRODUCT_ID + index"
          :item="item"
          :canBuy="true"
          :showDetailPopupBtn="true"
          @selectProduct="selectProduct"
        ></product-item>
      </div>
    </div>
    <div
      class="has-choose-product"
      v-if="(hasSelectProduct || hasLoadPaytype) && !isGsOrSupPayAutoSelect"
    >
      <span
        class="change-product j-change-product"
        @click="handleReSelectProduct"
        >{{ letter.storeChangeProduct }}</span
      >
      <product-item
        v-if="!isCart"
        :item="selectItem"
        :canBuy="false"
        :showDetailPopupBtn="false"
      ></product-item>
      <product-item
        v-if="isCart"
        :item="cartList[0]"
        :canBuy="false"
        :showDetailPopupBtn="false"
      ></product-item>
      <div
        v-if="isCart && cartList.length > 1"
        class="look-detail j-click-look-all-cart"
        @click="lookCart"
      >
        {{ letter.look_detail_product }}<span class="icon"></span>
      </div>
    </div>
    <cart-submit-footer v-if="isCart && !hasLoadPaytype"></cart-submit-footer>
    <transition name="fade">
      <product-detail-popup
        v-if="showDetailPopup"
        @selectProduct="selectProduct"
      ></product-detail-popup>
    </transition>
    <transition name="fade" mode="out-in">
      <PopupWindow
        class="coinPopup"
        :type="'tips'"
        :title="letter.notice"
        textAlign="left"
        :confirm="letter.popupConfirm"
        :content="letter[`${gameInfoConfig.gameCode}ProductOffTips`]"
        @onConfirm="productOffPopupState = false"
        @onCancel="productOffPopupState = false"
        :daysLimit="7"
        :limitKey="PRODUCT_OFF_POPUP_HIDE"
        :limitText="letter.hideWithinWeek"
        v-if="
          productList.length &&
          !productOffDayLimit &&
          !productOffLimitToday &&
          productOffPopupState &&
          hideNoticeForever
        "
      ></PopupWindow>
    </transition>
    <VoucherAboutPopup v-if="visibleVoucherAboutPopup"></VoucherAboutPopup>
    <SharePopup
      v-if="useShare"
      :visible="visibleSharePopup"
      @closeSharePopup="setSharePopup(false)"
    ></SharePopup>
  </div>
</template>

<script type="text/javascript">
import { getProductDefaultImg } from '@utiles/officialStore/productImg';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint';
import globalConfig from '@utiles/officialStore/globalConfig';
import { errorReport, ERROR_TYPE } from '@utiles/errorReport';
import {
  UPDATE_LOADING,
  LOAD_PAYTYPE_LIST_DATA,
  UPDATE_HAS_SELECT_PRODUCT,
  SET_VISIBLE_VOUCHER_ABOUT_POPUP
} from '@store/officialStore';
import {
  storeProductParam,
  storeCpProductId,
  getCurLocation,
  setDefaultPrice
} from '@store/officialStore/storager';
import {
  UPDATE_SHOW_CARTLIST_STATUS,
  UPDATE_IS_CART
} from '@store/officialStore/cart';
import VoucherAboutPopup from '@components/officialStore/activity/VoucherAboutPopup.vue';
import SharePopup from '@components/officialStore/activity/SharePopup.vue';
import ProductDetailPopup from '@components/officialStore/product/ProductDetailPopup.vue';
import ProductItem from '@components/officialStore/product/ProductItem.vue';
import CartSubmitFooter from '@components/officialStore/cart/CartSubmitFooter.vue';
import SectionTitle from '@components/officialStore/SectionTitle.vue';
import IScroll from '@utiles/iscroll';
import coupon from '@mixins/officialStore/coupon';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { getGameLanguage } from '@store/officialStore/gameConf';
import pay from '@mixins/officialStore/pay';
import gsOperate from '@mixins/officialStore/gsOperate';
import { clickButton } from '@plugins/biPoint/_configWebstoreV1';
const isFromIframe = globalConfig.getHrefParam('fromIframe') || '';
const PRODUCT_OFF_POPUP_HIDE = 'PRODUCT_OFF_POPUP_HIDE';
const PACKAGE_TAG_LIST = [
  'hot',
  'discount',
  'double',
  'treble',
  'sale',
  'top_seller',
  'off_10',
  'off_20',
  'off_30',
  'off_40',
  'off_50',
  'off_60',
  'off_70',
  'off_80',
  'off_90',
  'event',
  'daily',
  'weekly',
  'monthly'
];

export default {
  name: 'webSelectProduct',
  mixins: [coupon, pay, gsOperate],
  data() {
    return {
      uidGame: globalConfig.isUidGame(),
      mainHost: globalConfig.getMainHost(),
      curOrderType: 'normal',
      curProductType: '',
      searchVal: '',
      scroll: null,
      selectItem: {},
      hasAutoSelect: false,
      curSearchType:
        +globalConfig.getHrefParam('gameId') === 2 ? 'price' : 'name', // 日本江美商品名是个图片，没有名称搜索，初始化时为价格搜索
      productOffPopupState:
        this.$store.getters.gameInfoConfig.showProductOffTips, // 非代币商品下架提醒弹窗
      PRODUCT_OFF_POPUP_HIDE,
      hideNoticeForever: (() => {
        const curDate = new Date();
        const endDate = new Date('2023/3/19 00:00:00');
        return curDate.getTime() < endDate.getTime();
      })(),

      visibleSharePopup: false
    };
  },
  watch: {
    productType: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.isCustomProductType) {
          return;
        }
        this.$nextTick(() => {
          if (!this.scroll && this.productType.length) {
            let width = 160 * this.productType.length;
            this.$refs.productTypeContent.style.width = width + 'px';
            // productTypeWrap被绑定的这个元素要使用v-show，v-if会在其它操作触发后重新加载，导致该元素被销毁重建，ref绑定的是已经销毁的元素
            this.scroll = new IScroll(this.$refs.productTypeWrap, {
              mouseWheel: true,
              scrollX: true,
              tap: true
            });
          } else if (this.scroll) {
            this.scroll.refresh();
          }
        });
      }
    },
    allProductList: {
      deep: true,
      immediate: true,
      handler(newVal) {
        let productId = globalConfig.getHrefParam('productId') || '';
        let cpProductId = globalConfig.getHrefParam('cpProductId') || '';
        let productList = newVal;
        if (
          !this.hasAutoSelect &&
          productId &&
          cpProductId &&
          productList &&
          productList.length > 0
        ) {
          let productItem = productList.find(item => {
            return (
              item.CP_PRODUCT_ID == cpProductId && item.PRODUCT_ID == productId
            );
          });
          if (productItem) {
            this.autoSelectProduct(productItem);
          } else {
            errorReport(ERROR_TYPE.AUTO_MATCH_PRODUCT_FAIL, {
              productId,
              cpProductId
            });
          }
        }
      }
    },
    lang(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      }
    },
    gameActiveCouponId() {
      this.curProductType = 'typeall';
    },
    searchVal(newVal) {
      window.webstorev1DataLayer.push({
        eventName: 'search_product',
        eventType: this.curSearchType,
        eventReason: newVal
      });
    }
  },
  computed: {
    ...mapState({
      hasSelectProduct: state => state.hasSelectProduct,
      lang: state => state.lang,
      allProductList: state => state.productList,
      showDetailPopup: state => state.showDetailPopup,
      letter: state => state.letter,
      currency: state => state.showCurrency,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      cartList: state => state.cart.cartList,
      isCart: state => state.cart.isCart,
      uid: state => state.login.uid,
      gameId: state => state.gameId,
      isShowVoucherAboutPopup: state => state.visibleVoucherAboutPopup
    }),
    ...mapGetters(['gameInfoConfig', 'isJpPlatform']),
    useShare() {
      return this.gameInfoConfig.useShare;
    },
    isBlackFridayVersion() {
      return this.gameInfoConfig.isBlackFridayVersion;
    },
    productTypeImg() {
      return this.gameInfoConfig.productType;
    },
    isCustomProductType() {
      return this.gameInfoConfig.isCustomProductType;
    },
    notCartAndNoSelectProduct() {
      return !this.isCart && !this.hasSelectProduct;
    },
    isCartAndNoLoadPaytype() {
      return this.isCart && !this.hasLoadPaytype;
    },
    searchType() {
      if (this.gameId == 2) {
        return [{ name: this.letter.price, value: 'price' }];
      }
      return [
        { name: this.letter.product, value: 'name' },
        { name: this.letter.price, value: 'price' }
      ];
    },
    searchPlaceholder() {
      return {
        name: this.letter.storeInputNameSearch,
        price: this.letter.storeInputPriceSearch
      };
    },
    isDzg() {
      return [211, 209, 213, 215].includes(+this.gameId);
    },
    // 7天内隐藏商品下架公告弹窗
    productOffDayLimit() {
      return globalConfig.getCookie(PRODUCT_OFF_POPUP_HIDE);
    },
    // 7天内隐藏商品下架公告（当天是否已弹出）
    productOffLimitToday() {
      return globalConfig.getCookie(`${PRODUCT_OFF_POPUP_HIDE}_TODAY`);
    },
    // 是否展示代金币提示语
    showCoinTips() {
      return this.$store.getters.gameInfoConfig.showCoinTips;
    },
    productType() {
      const TYPES_NAME = {
        coin: this.isDzg ? this.dzgCoinType : this.letter.coinTypeName,
        package: this.letter.packageTypeName,
        subscription: this.letter.subscriptionTypeName,
        currency: this.isDzg
          ? this.dzgCurrencyType
          : this.letter.currencyTypeName,
        typeall: this.letter.typeall
      };
      let res = [];
      if (this.$store.state.productTypes.length < 1) {
        this.curProductType = '';
        return res;
      }
      this.$store.state.productTypes.map(item => {
        if (item) {
          res.push({
            name: this.isCustomProductType
              ? this.letter[item]
              : TYPES_NAME[item],
            value: item
          });
        }
      });
      this.curProductType = res[0].value;
      return res;
    },
    productList() {
      let realProductList = [].concat(
        this.searchVal.length
          ? this.searchProductList
          : this.$store.state.productList
      );
      let _productList = this.filterHideProduct(realProductList);
      _productList = this.filterUseGameCoupon(_productList);
      // 有商品列表时
      // 如果是gs链接跳转登录过来的，自动选择最后一个商品（最贵的）
      // 如果是补款链接跳转登录过来的，自动选择第一个商品（最便宜的）
      if (_productList.length > 0) {
        const productToSelect = this.isGsPay
          ? _productList[_productList.length - 1]
          : this.isSupplementaryPay
          ? _productList[0]
          : null;
        if (productToSelect) {
          this.autoSelectProduct(productToSelect);
        }
      }
      return this.filterOrder(_productList);
    },
    searchProductList() {
      return this.curSearchType === 'name'
        ? this.$store.getters.getProductListByName(this.searchVal)
        : this.$store.getters.getProductListByPrice(this.searchVal);
    },
    currencyTips() {
      return getGameLanguage(
        this.$store.state.lang,
        'currencyTips',
        this.gameId
      );
    },
    dzgCurrencyType() {
      return getGameLanguage(
        this.$store.state.lang,
        'currencyType',
        this.gameId
      );
    },
    dzgCoinType() {
      return getGameLanguage(this.$store.state.lang, 'coinType', this.gameId);
    },
    visibleVoucherAboutPopup() {
      //首次访问弹出
      if (this.gameInfoConfig?.isBlackFridayVersion && this.isLogin) {
        const hasAboutPopupShow =
          globalConfig.getLclStorageItem('ABOUT_POPUP_SHOWN');
        if (!hasAboutPopupShow) {
          this.setVoucherAboutPopup(true);
        }
        globalConfig.setLclStorageItem('ABOUT_POPUP_SHOWN', true);
      }
      return (
        this.gameInfoConfig?.isBlackFridayVersion &&
        this.isShowVoucherAboutPopup &&
        this.isLogin
      );
    }
  },
  methods: {
    ...mapMutations({
      setVoucherAboutPopup: SET_VISIBLE_VOUCHER_ABOUT_POPUP
    }),
    setSharePopup(visible) {
      this.visibleSharePopup = visible;
    },
    showVoucherAboutPopup() {
      this.setVoucherAboutPopup(true);
    },
    lookCart() {
      this.$store.commit(UPDATE_SHOW_CARTLIST_STATUS, true);
    },
    autoSelectProduct(item) {
      this.hasAutoSelect = true;
      this.selectProduct(item, true);
    },
    selectProduct(item, isAutoSelect = false) {
      let productId = item.PRODUCT_ID,
        cpProductId = item.CP_PRODUCT_ID,
        remark = item.REMARK;

      this.updateSelectProduct(item);
      const serverId = this.$store.state.serverId;
      const roleId = this.$store.state.roleId;
      if (!serverId || !roleId) {
        alert(this.letter.seletGameInfoFirst);
        return;
      }
      // 搜索打点
      if (this.searchVal.length) {
        commonEmitUpload(
          `search-product-by-${this.curSearchType}`,
          {
            event: `search-product-by-${this.curSearchType}`,
            newPage: true,
            pageName: 'select-product-page',
            type: 'click'
          },
          this.searchVal
        );
      }
      window.webstorev1DataLayer.push({
        eventName: 'select_product',
        eventType: 'buy_now',
        eventReason: isAutoSelect ? 'auto_select' : 'click_select',
        eventValue: {
          product_type: item.PRODUCT_TYPE || '',
          cp_product_id: cpProductId,
          product_id: productId,
          product_num: 1,
          product_currency: this.currency,
          product_money: item.GAME_AMOUNT || ''
        }
      });
      // let storeUrl = `//gabres.${mainHost}:8080/store.html`;
      // if (this.uidGame) {
      //   storeUrl = `//${window.location.host}/platform/store.html`;
      // }
      // const param =
      //   '?gameId=' +
      //   this.$store.state.gameId +
      //   '&serverId=' +
      //   this.$store.state.pcServerId +
      //   '&roleId=' +
      //   roleId +
      //   '&roleName=' +
      //   encodeURIComponent(this.$store.state.roleName) +
      //   '&productId=' +
      //   productId +
      //   '&cpProductId=' +
      //   cpProductId +
      //   '&remark=' +
      //   remark +
      //   '&loginAccount=' +
      //   this.$store.state.login.loginAccount +
      //   '&userId=' +
      //   this.$store.state.login.uid +
      //   '&web=1' +
      //   '&language=' +
      //   this.$store.state.lang +
      //   '&appLanguage=' +
      //   this.$store.state.lang +
      //   '&fromIframe=' +
      //   isFromIframe +
      //   '&pageSource=' +
      //   pageSource +
      //   '&cid=' +
      //   globalConfig.getHrefParam('cid') +
      //   '&scid=' +
      //   globalConfig.getHrefParam('scid') +
      //   '&packageName=' +
      //   globalConfig.getHrefParam('packageName') +
      //   '&hideService=' +
      //   globalConfig.getHrefParam('hideService') +
      //   '#/web';
      //先不跳了
      // window.location.href = storeUrl + param;
      // 保存跳到储值页前的链接，为了返回时能获取跳过去前的信息
      const saveLinks =
        '?gameId=' +
        this.$store.state.gameId +
        '&serverId=' +
        serverId +
        '&roleId=' +
        roleId +
        '&roleName=' +
        encodeURIComponent(this.$store.state.roleName) +
        '&productId=' +
        productId +
        '&cpProductId=' +
        cpProductId +
        '&remark=' +
        remark +
        '&loginAccount=' +
        this.$store.state.login.loginAccount +
        '&userId=' +
        this.$store.state.login.uid +
        '&web=1' +
        '&language=' +
        this.$store.state.lang +
        '&appLanguage=' +
        this.$store.state.lang +
        '&fromIframe=' +
        isFromIframe +
        '&cid=' +
        globalConfig.getHrefParam('cid') +
        '&scid=' +
        globalConfig.getHrefParam('scid') +
        '&packageName=' +
        globalConfig.getHrefParam('packageName') +
        '&hideService=' +
        globalConfig.getHrefParam('hideService') +
        '&productType=' +
        item.PRODUCT_TYPE +
        '#/web';
      sessionStorage.setItem('forwardLinksParam', saveLinks);
      storeProductParam({
        gameId: this.$store.state.gameId,
        serverId: this.$store.state.pcServerId,
        roleId: roleId,
        roleName: this.$store.state.roleName,
        packageName: globalConfig.getHrefParam('packageName'),
        userId: this.uid,
        productId: productId,
        cpProductId: cpProductId,
        devicePlate: globalConfig.getHrefParam('devicePlate'),
        remark: remark,
        // location: globalConfig.getHrefParam('location'),
        location: getCurLocation() || '',
        appLanguage: this.$store.state.lang,
        language: this.$store.state.lang,
        productType: item.PRODUCT_TYPE
      });
      storeCpProductId(cpProductId);
      globalConfig.storeEntryParams();
      setDefaultPrice('');
      this.$store.commit(UPDATE_LOADING, true);
      this.$store.commit(UPDATE_IS_CART, false);
      this.$store.dispatch(LOAD_PAYTYPE_LIST_DATA);
    },
    updateOrderType(value) {
      if (value === 'normal') {
        this.curOrderType = value;
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'auto'
        });
        return;
      }
      if (this.curOrderType === 'priceUp') {
        this.curOrderType = 'priceDown';
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'price_down'
        });
      } else {
        this.curOrderType = 'priceUp';
        clickButton({
          btnName: 'switch_sorting',
          locationKey: 'price_up'
        });
      }
    },
    updateProductType(value) {
      clickButton({
        btnName: 'switch_producttype',
        locationKey: value
      });
      this.curProductType = value;
    },
    getProductDefaultIcon(type) {
      return getProductDefaultImg(type);
    },
    updateSelectProduct(item) {
      this.selectItem = item;
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, true);
    },
    filterHideProduct(realProductList) {
      let productList = [];
      for (let key in realProductList) {
        //需求方：区天衡 -  如果CP_PRODUCT_ID为10_1_-1 11_1_-1 12_1_-1 13_1_-1 426005_1_-1，则不显示
        let hideProductArr = [
          '10_1_-1',
          '11_1_-1',
          '12_1_-1',
          '13_1_-1',
          '426005_1_-1'
        ];
        if (
          realProductList[key].CP_PRODUCT_ID &&
          hideProductArr.includes(String(realProductList[key].CP_PRODUCT_ID))
        ) {
          continue;
        }

        if (
          this.curProductType &&
          this.curProductType !== 'typeall' &&
          this.curProductType != realProductList[key].itemType
        ) {
          continue;
        }

        productList.push(realProductList[key]);
      }

      return productList;
    },
    filterUseGameCoupon(productList) {
      if (
        this.gameActiveCouponId &&
        this.activeGameCouponProductList.length > 0
      ) {
        return productList.filter(item => {
          return this.checkInGameActiveCoupon(
            item.PRODUCT_ID,
            item.CP_PRODUCT_ID
          );
        });
      }
      return productList;
    },
    filterOrder(productList) {
      let res = [];
      let isPackage = this.curProductType == 'package';

      switch (this.curOrderType) {
        // 默认排序
        case 'normal': {
          let tagArr = [];
          let notagArr = [];
          // 先区分是否有tag
          productList.forEach(item => {
            // 只处理礼包的tag，非礼包的不处理
            if (isPackage) {
              if (item.PRODUCT_TAG) {
                // 插入的时候排一下序（tag权重）
                let orderIndex = tagArr.length - 1;
                let isAdd = false;
                while (~orderIndex) {
                  const preTagOrder = PACKAGE_TAG_LIST.indexOf(
                    tagArr[orderIndex].PRODUCT_TAG
                  );
                  const curTagOrder = PACKAGE_TAG_LIST.indexOf(
                    item.PRODUCT_TAG
                  );
                  if (preTagOrder >= curTagOrder) {
                    tagArr.splice(+orderIndex + 1, 0, item);
                    isAdd = true;
                    break;
                  } else {
                    orderIndex--;
                  }
                }
                if (!isAdd) {
                  tagArr.unshift(item);
                }
              } else {
                notagArr.push(item);
              }
            } else {
              notagArr.push(item);
            }
          });
          // 如果都没有tag，就可以结束了
          if (!tagArr.length) {
            res = notagArr;
            break;
          }
          res = tagArr.concat(notagArr);
          break;
        }
        // 价格升序
        case 'priceUp': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT > +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        // 价格降序
        case 'priceDown': {
          productList.sort((a, b) => {
            let bTagOrder = b.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(b.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;
            let aTagOrder = a.PRODUCT_TAG
              ? PACKAGE_TAG_LIST.indexOf(
                  String(a.PRODUCT_TAG).toLocaleLowerCase()
                )
              : -2;

            if (
              +b.GAME_AMOUNT < +a.GAME_AMOUNT ||
              (isPackage &&
                b.GAME_AMOUNT == a.GAME_AMOUNT &&
                bTagOrder < aTagOrder)
            ) {
              return -1;
            } else {
              return 1;
            }
          });

          res = productList;
          break;
        }
        default:
          break;
      }
      return res;
    }
  },
  components: {
    ProductDetailPopup,
    ProductItem,
    CartSubmitFooter,
    SectionTitle,
    VoucherAboutPopup,
    SharePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.select-product {
  position: relative;
}
.share-page-btn {
  width: 45px;
  height: 45px;
  position: absolute;
  top: -25px;
  right: 52%;
  transform: translate(370px, 0);
  display: inline-block;
  background-size: contain;
  @psetbg ('share-page-btn.png',false,false);
}
.unlogin-tip {
  text-align: center;
  font-size: 24px;
  color: #c1a15e;
}
.coinTips {
  text-align: center;
  font-size: 24px;
  color: var(--product-coin-tips);
  padding: 0 30px;
  margin-bottom: 20px;
  line-height: 1.3;
}
.product-wrap {
  overflow: -moz-scrollbars-none;
  overflow-y: scroll;
  // max-height: 875px;
  height: 875px;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0 !important;
  }
}
.choose-product-title {
  margin: 94px auto 33px;
}
.search-type-wrap {
  box-sizing: border-box;
  padding: 46px 24px;
  background-size: cover;
  @psetbg ('product-type-wrap-bg.png', false);
  .tips {
    color: var(--product-tips);
    font-size: 22px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .search-wrap {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 65px;
  }
  .search-tips {
    margin: 9px auto 0;
    text-align: center;
    font-size: 20px;
    color: var(--product-search-tip);
    word-break: break-word;
  }
  .voucher-about-btn {
    display: flex;
    align-items: center;
    font-size: 21px;
    color: #ffffff;
    .about-icon {
      display: inline-block;
      background-size: cover;
      @psetbg ('about-icon.png');
    }
  }
  .search-input-wrap {
    position: relative;
    margin-left: 20px;
    width: 446px;
    height: 65px;
    @psetbg ('search-input.png');
    background-size: contain;
  }
  .search-input {
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    padding: 0 70px 0 38px;
    outline: none;
    background-color: transparent;
    background-size: cover;
    line-height: 65px;
    font-size: 24px;
    color: var(--input-product-search);
    &::-webkit-search-cancel-button {
      display: none;
    }
    &::placeholder {
      color: var(--input-product-search);
    }
  }
  .search-input-ico {
    display: inline-block;
    position: absolute;
    right: 29px;
    top: 50%;
    background-size: cover;
    transform: translateY(-50%);
    @psetbg ('search-input-ico.png');
  }
  .select-search-type {
    position: relative;
    padding: 0 !important;
    background-size: contain;
    font-size: 24px;
    @psetbg ('search-type.png');
    ::v-deep .select {
      box-sizing: border-box;
      padding: 0 0 0 8px;
      background-size: cover;
      color: var(--input-product-search) !important;
    }
  }
  .product-type-select {
    overflow: -moz-scrollbars-none;
    overflow-x: hidden;
    overflow-y: auto;
    margin: -10px auto 0;
    width: 720px;
    height: 230px;
    white-space: nowrap;

    touch-action: none;
    touch-action: pan-y;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .content {
      display: flex;
      justify-content: flex-start;
    }
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    &-item {
      position: relative;
      flex-shrink: 0;
      margin-left: -55px;
      background-size: cover;
      cursor: auto;
      text-align: center;
      font-size: 22px;
      color: var(--product-type-text);

      touch-action: none;
      touch-action: pan-y;
      @psetbg ('product-type-item-bg.png');
      &.cur {
        // 这里
        touch-action: none;
        @psetbg ('product-type-item-bg-active.png');
      }
      &-click {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 142px;
        height: 142px;
        transform: translate(-50%, -50%);
      }
      &:hover {
        cursor: pointer;
      }
      &:last-child {
        margin-right: 0;
      }
      &:first-child {
        margin-left: -38px;
      }
      .type-img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 88px;
        height: 88px;
        transform: translate(-50%, -50%);
      }
      .type-name {
        position: absolute;
        left: 50%;
        top: 184px;
        width: 65%;
        text-align: center;
        word-break: break-all;
        white-space: break-spaces;
        transform: translateX(-50%);
      }
    }
  }
}
.order-type-wrap {
  display: flex;
  justify-content: space-between;
  margin: 34px 0 18px;
  padding: 0 24px;
  &-left {
    display: flex;
  }
  .order-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 17px;
    background-size: cover;
    text-align: center;
    font-size: 22px;
    color: var(--product-order-btn);
    @psetbg ('order-btn.png');
    &.active {
      color: var(--product-order-btn-active);
      @psetbg ('order-btn-active.png');
    }
    .price-up {
      display: inline-block;
      margin-left: 5px;
      width: 12px;
      height: 23px;
      background: url($pnsImg + 'up.png') no-repeat top;
      background-size: cover;
    }
    .price-down {
      display: inline-block;
      margin-left: 5px;
      width: 12px;
      height: 23px;
      background: url($pnsImg + 'down.png') no-repeat top;
      background-size: cover;
    }
  }
  .coupon-tag {
    margin-left: 92px;
    padding: 0 16px;
    border: 1px solid var(--product-coupon-border);
    height: 55px;
    background: var(--product-coupon-bg);
    line-height: 55px;
    font-size: 22px;
    color: var(--product-coupon-text);
    &-close {
      display: inline-block;
      background-size: cover;
      @psetbg ('coupon-tag-close.png');
    }
  }
}
.uid-tips {
  margin: -1vh auto 2vh 0;
  font-size: 1.6vh;
  color: #f65353;
  word-break: break-word;
}
.select-product-order,
.not-select {
  border: none;
  .product-icon,
  .product-price {
    display: none;
  }
}
.has-choose-product {
  .change-product {
    display: inline-block;
    margin-bottom: 25px;
    padding-left: 24px;
    cursor: pointer;
    font-size: 28px;
    color: var(--product-change-product);
  }
  .look-detail {
    cursor: pointer;
    text-align: center;
    font-size: 24px;
    color: var(--product-look-cart);
    .icon {
      display: inline-block;
      margin-left: 5px;
      @psetbg ('look-detail.png');
      background-size: cover;
    }
  }
}
.ico {
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  @psetbg ('order-ico.png');
}
@media screen and (orientation: landscape) {
  .search-type-wrap {
    .search-input-wrap {
      width: 819px;
      @psetbg ('search-input-hen.png');
    }
    .product-type-select {
      width: 1000px;
    }
    .select-search-type {
      font-size: 20px;
    }
    .search-input {
      font-size: 20px;
    }
  }
  .order-type-wrap {
    padding: 0 0;
    .coupon-tag {
      margin-left: 0;
    }
  }
  .product-wrap {
    overflow: -moz-scrollbars-none;
    height: 883px;

    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    .product-box-wrap {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .has-choose-product {
    margin: 0 auto;
    width: 703px;
    .change-product {
      padding-left: 0;
    }
    .product-box {
      margin-left: 0;
    }
  }
}
</style>
